export const ContentDisplayType = {
  TOOLTIP: 'tooltip',
  DIALOG: 'dialog',
};

export default {
  ContentDisplayType,
};
